import { Box, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import React from "react";
import dayjs from "dayjs";
import StatusChip from "./StatusChip";

export default function JobCardPhaseRow({
  phase,
  job,
  indented,
  handlePhaseClick,
}: {
  phase: any;
  job: any;
  indented?: boolean;
  handlePhaseClick: (e: React.MouseEvent, phaseId: string) => void;
}) {
  return (
    <Box sx={{ mb: 1, pl: indented ? 2 : 1, backgroundColor: indented ? "#f7f7f7" : undefined }}>
      <Box
        draggable={phase.status === "TO_BE_SCHEDULED"}
        data-draggable={phase.status === "TO_BE_SCHEDULED" ? "true" : "false"}
        data-phase-data={
          phase.status === "TO_BE_SCHEDULED"
            ? JSON.stringify({
                type: "jobPhase",
                phaseId: phase.id,
                jobId: job.id,
                phaseName: phase.productName || "Unknown",
                jobAddress: job.address?.line1 || "Unknown Address",
                jobExternalId: job.externalId,
                duration: phase.jobDuration || 0,
                total: phase.proposedOverallTotal,
              })
            : ""
        }
        onClick={(e) => handlePhaseClick(e, phase.id)}
        onDragStart={(e) => {
          if (phase.status === "TO_BE_SCHEDULED") {
            const phaseData = {
              type: "jobPhase",
              phaseId: phase.id,
              jobId: job.id,
              phaseName: phase.productName || "Unknown",
              jobAddress: job.address?.line1 || "Unknown Address",
              jobExternalId: job.externalId,
              duration: phase.jobDuration || 0,
              total: phase.proposedOverallTotal,
            };
            e.dataTransfer.setData("text/plain", JSON.stringify(phaseData));
            e.dataTransfer.effectAllowed = "copy";
          }
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
          cursor: "pointer",
          "&:active": {
            cursor: phase.status === "TO_BE_SCHEDULED" ? "grabbing" : "pointer",
          },
          "&:hover": { backgroundColor: "#f0f4f8" },
          borderRadius: "4px",
          padding: "4px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {phase.status === "TO_BE_SCHEDULED" && (
            <DragIndicatorIcon
              sx={{ fontSize: "0.875rem", color: "#9e9e9e", pointerEvents: "none" }}
            />
          )}
          <Typography variant="caption" fontWeight="medium">
            Phase: {phase.productName || "Unknown"}
          </Typography>
        </Box>
        <StatusChip status={phase.status} />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 1,
          ml: 2,
        }}
      >
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", fontWeight: "medium" }}
          >
            Start Date
          </Typography>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{ display: "block", fontSize: "0.75rem" }}
          >
            {phase.startsAt
              ? dayjs.utc(phase.startsAt).local().format("MM/DD/YYYY")
              : "Not scheduled"}
          </Typography>
        </Box>
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", fontWeight: "medium" }}
          >
            Hours
          </Typography>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{ display: "block", fontSize: "0.75rem" }}
          >
            {(phase.jobDuration || 0).toFixed(1)}
          </Typography>
        </Box>
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", fontWeight: "medium" }}
          >
            Total
          </Typography>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{ display: "block", fontSize: "0.75rem", color: "#0d804a" }}
          >
            {formatCentsToUSD(phase.proposedOverallTotal)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
